import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { IoAlertCircleOutline } from 'react-icons/io5';

import styles from './OutOfWaterWarningModal.module.scss';

interface OutOfWaterWarningModalProps {
  open: boolean;
  onClose: () => void;
  onChangeEvent: () => void;
  onGoOn: () => void;
}

const OutOfWaterWarningModal = ({
  open,
  onClose,
  onChangeEvent,
  onGoOn,
}: OutOfWaterWarningModalProps) => {
  const dialogRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div
        ref={dialogRef}
        className={styles.dialog}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className={styles.content}>
          <div className={styles.iconWrapper}>
            <IoAlertCircleOutline color="#F59E0B" className={styles.icon} />
          </div>
          <h2 className={styles.title}>Out of Water</h2>
          <p className={styles.description}>
            This vessel will be out of the water during this event.
          </p>
        </div>
        <div className={styles.actions}>
          <button type="button" className={styles.actionButton} onClick={onChangeEvent}>
            Change Event
          </button>
          <button type="button" className={styles.actionButtonWarning} onClick={onGoOn}>
            Keep Event
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default OutOfWaterWarningModal;
